import React, { Component } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from "react-router-dom";
import { connect } from "react-redux";
import { checkSession } from "./components/auth/auth-actions";
import Layout from "./components/layout/layout";
import DashboardSummary from "./components/dashboard-summary/dashboard-summary";
import Welcome from "./components/welcome/welcome";
import AvailableDrivers from "./components/available-drivers-list/available-drivers-list";
import Map from "./components/available-drivers-map/available-drivers-map";
import Payment from "./components/payment/payment";
import ErrorMessage from "./components/snackbars/snackbars";
import UsersAndPermissions from "./components/users-and-permissions/users-and-permissions";
import ReAuthenticate from "./components/login/re-authenticate";
import ManageDrivers from "./components/manage-drivers/manage-drivers";
import ResetPassword from "./components/reset-password/reset-password";
import PastBookings from "./components/past-bookings/past-bookings";
import ScheduledBookings from "./components/scheduled-bookings/scheduled-bookings";
import NewUser from "./components/new-user/new-user";

class App extends Component {
  componentDidMount() {
    this.props.checkSession(this.props.isLoggedIn); // pass persisted auth
  }

  render() {
    return (
      <Router>
        <Switch>
          <AuthRoute
            check={this.props.auth}
            path={"/past-bookings"}
            component={PastBookings}
            headerTitle={"Previous bookings"}
          />
          <AuthRoute
            check={this.props.auth}
            path={"/scheduled-bookings"}
            component={ScheduledBookings}
            headerTitle={"Scheduled bookings"}
          />
          <AuthRoute
            check={this.props.auth}
            exact
            path={"/"}
            component={DashboardSummary}
            headerTitle={"Overview"}
          />
          <AuthRoute
            check={this.props.auth}
            path={"/available-drivers"}
            component={AvailableDrivers}
            headerTitle={"Available drivers"}
          />
          <AuthRoute
            check={this.props.auth}
            path={"/manage-drivers"}
            component={ManageDrivers}
            headerTitle={"Drivers"}
          />
          <AuthRoute
            check={this.props.auth}
            path={"/map"}
            component={Map}
            headerTitle={"Map of drivers"}
          />
          <AuthRoute
            check={this.props.auth}
            path={"/payment"}
            component={Payment}
            headerTitle={"Payment settings"}
          />
          <AuthBusinessOnlyRoute
            check={this.props.auth}
            path={"/users-and-permissions"}
            component={UsersAndPermissions}
            headerTitle={"Users and permissions"}
          />
          <NoAuthRoute
            check={this.props.auth}
            path={"/re-authenticate"}
            component={ReAuthenticate}
          />
          <NoAuthRoute
            check={this.props.auth}
            path={"/reset-password"}
            component={ResetPassword}
            headerTitle={"Reset Password"}
          />
          <NoAuthRoute
            check={this.props.auth}
            path={"/new-user"}
            component={NewUser}
            headerTitle={"New User"}
          />

          <Route render={() => <Redirect to={"/"} />} />
        </Switch>
        <ErrorMessage />
      </Router>
    );
  }
}

const NoAuthRoute = ({ check, ...props }) => {
  if (check.isLoggedIn) return <Redirect to={"/"} />;
  return <Route {...props} />;
};

const AuthRoute = ({ check, ...props }) => {
  if (check.isLoggedIn)
    return (
      <Layout {...props}>
        <Route {...props} />
      </Layout>
    );
  if (check.sessionExpired) return <Redirect to={"/re-authenticate"} />;
  if (props.path === "/") return <Welcome />;
  return <Redirect to={"/"} />;
};

const AuthBusinessOnlyRoute = ({ check, ...props }) => {
  if (check.isLoggedIn && check.business)
    return (
      <Layout {...props}>
        <Route {...props} />
      </Layout>
    );
  if (check.sessionExpired) return <Redirect to={"/re-authenticate"} />;
  if (props.path === "/") return <Welcome />;
  return <Redirect to={"/"} />;
};

const mapStateToProps = state => ({ auth: state.auth });
const mapDispatchToProps = { checkSession: checkSession };
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/App.js